import React from 'react'
import DashboardData from 'components/Dashboard/Admin'
import Layout from 'components/LayoutForPortal'
const Index = () => {
    return (
        <Layout>
            <DashboardData />
        </Layout>
    )
}

export default Index;